import PropTypes from 'prop-types'
import { Fragment } from 'react'
import { kuiperClassNames } from '../../utils'

const Title = ({
  badge = null,
  htmlId,
  styleOverrides = {},
  title,
  tooltip,
}) => (
  <Fragment>
    <div
      className={kuiperClassNames('title')}
      css={styleOverrides}
      title={tooltip ? null : title}
    >
      <span aria-hidden id={htmlId}>
        {title}
      </span>
    </div>
    {badge && <div className={kuiperClassNames('badge')}>{badge}</div>}
  </Fragment>
)

Title.propTypes = {
  badge: PropTypes.string,
  styleOverrides: PropTypes.object,
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.any,
  htmlId: PropTypes.string,
}

export default Title
